import './timeline.scss';

// Config
import { colors } from '../../config/status';

// Components
import ListItem from '../list-item/list-item';

const Timeline = ({ items }) => {
	return (
		<div className="timeline">
			{items?.map((item, index) => {
				return (
					<div className="timeline__item" key={(item.title || item.code) + index}>
						<div
							className="timeline__item__color"
							style={{
								background: colors[item.status],
								height: index === items.length - 1 && '0px'
							}}
						></div>
						<ListItem item={item} />
					</div>
				);
			})}
		</div>
	);
};

export default Timeline;
